<template>
  <!-- overlay-class="web-view-overlay" -->
  <van-popup
    v-model:show="webViewPopupConfig.iShow"
    position="bottom"
    :class="['web-view-popup', webViewPopupConfig.popupClass]"
    teleport="body"
    @open="isShowIframe = true"
    @closed="closed"
  >
    <div v-if="isShowIframe" class="iframe-container">
      <iframe
        :id="webViewId"
        :src="webViewPopupConfig.src"
        width="100%"
        height="100%"
        frameborder="0"
        scrolling="no"
      ></iframe>
    </div>
  </van-popup>
</template>
<!-- 游戏webView弹窗 -->
<script setup lang="ts">
defineOptions({ name: 'WebViewPopup' })

const webViewId = ref<string>(webBridge.webViewId)

// 监听路由，切换页面关闭弹窗
const router = useRouter()
router.afterEach(() => {
  closed()
})

// 公共模块store
const publicStore = usePublicStore()
const { webViewPopupConfig } = storeToRefs(publicStore)

watch(
  () => webViewPopupConfig.value.iShow,
  () => {
    if (webViewPopupConfig.value.iShow) {
      // 开启监听
      nextTick(() => {
        webBridge.startMessage()
      })
    }
  },
  {
    immediate: true
  }
)

// 是否关闭 iframe，用这关闭是为了保留 van-popup 关闭的效果，用 closed 回调再关闭
const isShowIframe = ref<boolean>(false)

function closed() {
  // 移除监听
  webBridge.removeMessage()
  isShowIframe.value = false
  publicStore.setWebViewPopupConfig({ isShow: false, popupClass: '' })
}
</script>

<style lang="scss">
.web-view-overlay {
  background: transparent;
}
.web-view-popup {
  right: 0;
  margin: 0 auto;
  width: 375px;
  height: 100%;
  background: transparent;
  @include media-screen(mobile) {
    width: 100%;
  }
  &.fishing-popup {
    height: 375px;
  }
  .iframe-container {
    width: 100%;
    height: 100%;
    overflow: hidden; // 暂时推荐是为了隐藏滚动条
    iframe {
      width: 100%;
      height: 100%;
      background: transparent;
    }
  }
}
</style>
